/*global Ractive, RedmarineUXTemplates, BaseComponent */

// Add component to Global Ractive object
Ractive.components['ux-accordion'] = BaseComponent.extend({

	template: RedmarineUXTemplates.uxaccordionUxaccordion,

	events: {
		uparrow: RactiveEventsKeys.uparrow,
		downarrow: RactiveEventsKeys.downarrow,
		enter: RactiveEventsKeys.enter,
		space: RactiveEventsKeys.space
	},

	// any default data
	data: {
		component: 'ux-accordion',
		fireOnInitialSelection: true,
		isActive: function(index) {
			return index === this.get('activeIndex');
		}
	},

	// add you behavious here
	onrender: function() {
		// select an item
		this.on('select', function(event) {
			var activeIndex = this.get('activeIndex'),
				newIndex = parseInt(event.keypath.split('.').pop());
			if (activeIndex === newIndex) {
				newIndex = -1;
			}

			this.set('activeIndex', newIndex).then(function() {
				if (newIndex > -1) {
					this.fire('onSelect', this.get('items.' + this.get('activeIndex')));
				}
			}.bind(this));

			return false;
		}.bind(this));
	},

	oncomplete: function() {
		if (this.get('fireOnInitialSelection')) {
			var item = this.get('items.' + this.get('activeIndex'));
			this.fire('onSelect', item);
		}
	}
});
